import { useCallback, useEffect, useState } from "react";
import { del, get, post, put } from "../api";

/**
 * The whole application registry (`scope=all`), which is what the management screen edits —
 * as opposed to `ApplicationsContext`, which holds only the applications the current user may
 * open from the nav.
 */
export default function useManagedApplications() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setApplications(await get("/api/applications?scope=all"));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const createApplication = useCallback(
    async (payload) => {
      await post("/api/applications", payload);
      await load();
    },
    [load]
  );

  const updateApplication = useCallback(
    async (applicationId, payload) => {
      await put(`/api/applications/${applicationId}`, payload);
      await load();
    },
    [load]
  );

  const deleteApplication = useCallback(
    async (applicationId) => {
      await del(`/api/applications/${applicationId}`);
      await load();
    },
    [load]
  );

  return {
    applications,
    loading,
    error,
    reload: load,
    createApplication,
    updateApplication,
    deleteApplication,
  };
}
